import { defineOperationManifest } from "../define"

export const textGenerateManifest = defineOperationManifest({
	type: "text.generate",
	ability: "ai.generate-text",
	bocLabelKey: "operations.boc.types.textGenerate",
})
